import { Autocomplete, TextField } from "@mui/material"
import { useCallback, useState } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { useDependencyInjection } from "../../config/di/dependency_injection_context";
import { usePageLoader } from "../contexts/page_content_context";
import { processError } from "../utils/base_error";
import { usePageStartBootstrap } from "../hooks/use_page_start_bootstrap";
import { DropDown } from "../domain/models/dropdown";

/**
 * DropDownProdutoServico
 */

type Props<F extends {}> = {
  name: keyof F,
  label?: string,
  required?: boolean,
  readOnly?: boolean,
  placeholder?: string,
  reactHookForm: UseFormReturn<F>,
  idContrato: number
};

export const DropDownProdutoServicoContrato = <F extends {},>({
  name,
  label,
  required,
  readOnly,
  placeholder,
  reactHookForm,
  idContrato
}: Props<F>) => {

  const { pushErrorNotification } = usePageLoader();
  const [produtoServicoContratoDropDown, setProdutoServicoContratoDropDown] = useState<DropDown[]>([]);

  const {
    commons: {
      getProdutoServicoContratoDropDownUseCase,
    },

  } = useDependencyInjection();


  const loadProdutoServicoDropDown = useCallback(async () => {
    try {

      const result = await getProdutoServicoContratoDropDownUseCase.getProdutoServicoContratoDropDown(idContrato);
      setProdutoServicoContratoDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar Produto/Serviços do contrato!'));
    }
  }, [getProdutoServicoContratoDropDownUseCase, idContrato, pushErrorNotification]);


  usePageStartBootstrap(async () => {
    loadProdutoServicoDropDown();
  })

  return (
    <>

      {/* DROPDOWN */}

      <Controller
        name={name as any}
        control={reactHookForm.control}
        render={({ field, formState }) => {
          let helperText: string | null = null;

          if (formState.errors[name as keyof typeof formState.errors]) {
            const fieldError = formState.errors[name] as any;
            if (fieldError?.message && typeof fieldError.message === 'string') {
              helperText = fieldError.message;
            }
          }


          return (
            <Autocomplete
              fullWidth={true}
              size="small"
              disablePortal
              options={produtoServicoContratoDropDown}
              getOptionKey={opt => opt.id}
              getOptionLabel={(opt) => opt.title}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              sx={{ minHeight: 45 }}
              readOnly={readOnly}
              disabled={formState.disabled}
              value={produtoServicoContratoDropDown.find(x => x.id === field.value) ?? null}
              onChange={(_, newValue) => field.onChange(newValue ? newValue.id : undefined)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label={label}
                  error={helperText !== null}
                  helperText={helperText}
                  placeholder={placeholder}
                  required={required}
                />
              )}
            />
          );
        }}
      />
    </>
  );
};
